import { render, staticRenderFns } from "./DigitalClinicsSelectClinician.vue?vue&type=template&id=865aebba"
import script from "./DigitalClinicsSelectClinician.vue?vue&type=script&lang=js"
export * from "./DigitalClinicsSelectClinician.vue?vue&type=script&lang=js"
import style0 from "./DigitalClinicsSelectClinician.vue?vue&type=style&index=0&id=865aebba&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports